// biome-ignore lint: disable

import { ChakraProvider } from '@chakra-ui/react';
import { MDXProvider } from '@mdx-js/react';
import type { WrapPageElementBrowserArgs } from 'gatsby';
import type * as React from 'react';
import { SupportImage } from './images/SupportImage';
import { SiteShell } from './layout/SiteShell';
import { AnchorHeading } from './SupportPage/AnchorHeading';

const STANDALONE_PATHS = ['/pricing-update/'];

const mdxComponents = {
  SupportImage,
  h2: (props: React.HTMLAttributes<HTMLHeadingElement>) => (
    <AnchorHeading as="h2" {...props} />
  ),
  h3: (props: React.HTMLAttributes<HTMLHeadingElement>) => (
    <AnchorHeading as="h3" {...props} />
  ),
};

export const wrapPageElement = ({
  element,
  props,
}: WrapPageElementBrowserArgs) => {
  const { pathname } = props.location;
  // Every page gets the site chrome (nav + footer). Campaign pages
  // with their own design stay standalone.
  const isStandalone = STANDALONE_PATHS.some(
    (p) => pathname.replace(/\/$/, '') === p.replace(/\/$/, ''),
  );
  return (
    <ChakraProvider resetCSS>
      <MDXProvider components={mdxComponents}>
        {isStandalone ? element : <SiteShell>{element}</SiteShell>}
      </MDXProvider>
    </ChakraProvider>
  );
};
